import { listaSdgs } from 'data/sdgs'

export const getColoreSdg = (sdg) => {
    const index = listaSdgs.findIndex((el) => el.number === sdg)
    return listaSdgs[index].color
}
